import axios from 'axios'

// withCredentials: true —— 跨域（本地 dev 前端 3000 直连后端 8686）也要携带
// refresh_token cookie，否则 /front/auth/refresh 拿不到 cookie 会 401，access token 过期后被踢登录
const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/api/v1',
  timeout: 10000,
  withCredentials: true
})

const refreshApi = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/api/v1',
  timeout: 10000,
  withCredentials: true
})

let isRefreshing = false
let failedQueue = []
let bannedNotified = false

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve(token)
    }
  })
  failedQueue = []
}

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

api.interceptors.response.use(
  response => response.data,
  async error => {
    const originalRequest = error.config

    // 用户被封禁，直接跳转登录页（不 reject，避免各 catch 块重复弹窗）
    if (error.response?.status === 401 && error.response?.data?.code === 2105) {
      if (!bannedNotified) {
        bannedNotified = true
        localStorage.removeItem('token')
        window.dispatchEvent(new CustomEvent('auth:banned'))
      }
      return new Promise(() => {})
    }

    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject })
        }).then(token => {
          originalRequest.headers.Authorization = `Bearer ${token}`
          return api(originalRequest)
        })
      }

      originalRequest._retry = true
      isRefreshing = true

      try {
        const res = await refreshApi.post('/front/auth/refresh')
        const newToken = res.data.data.token
        localStorage.setItem('token', newToken)
        localStorage.setItem('tokenTimestamp', Date.now().toString())
        processQueue(null, newToken)
        originalRequest.headers.Authorization = `Bearer ${newToken}`
        return api(originalRequest)
      } catch (refreshError) {
        processQueue(refreshError, null)
        localStorage.removeItem('token')
        window.location.href = '/login'
        return Promise.reject(refreshError)
      } finally {
        isRefreshing = false
      }
    }

    return Promise.reject(new Error(error.response?.data?.message || '请求失败'))
  }
)

export { api, refreshApi }
